<div fxLayout="column" fxLayoutAlign="center end">
    <div>Welcome {{ Application?.FirstName || User?.Email }} (<span fxHide.xs>Reference </span>ID: {{ User?.UserID }})</div>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <div *ngIf="User?.IsImpersonation">(Impersonated)</div>
        <button type="button" class="medium margin-top-thin margin-bottom-thin" mat-raised-button color="amber" (click)="Logout()">
            Log Out
        </button>
    </div>
</div>
